import { render, staticRenderFns } from "./iframeSection.vue?vue&type=template&id=64f68e90&scoped=true"
import script from "./iframeSection.vue?vue&type=script&lang=js"
export * from "./iframeSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f68e90",
  null
  
)

export default component.exports